<template>
  <div>
    <v-expansion-panels v-model="panel" multiple>
      <v-expansion-panel v-for="i in numberOfPanels" :key="i">
        <v-expansion-panel-header disable-icon-rotate>
          <template #actions>
            <v-icon :class="iconClass(i)">mdi-close</v-icon>
          </template>
          <slot :name="`title-${i}`"></slot>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <slot :name="`body-${i}`"></slot>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  name: 'normalAccordion',
  props: {
    /**
     * パネルの数を指定します。
     * パネルに表示する内容はslotで取得しており、
     * タイトル部分は"title-${パネルの要素数}"
     * 中身は"body-${パネルの要素数}"で取得しています。
     */
    numberOfPanels: {
      type: Number,
      default: 1
    }
  },
  data: () => {
    return {
      panel: []
    }
  },
  computed: {
    iconClass() {
      const panel = this.panel
      return function (key) {
        return panel.includes(key - 1) ? 'icon-close' : 'icon-plus'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.v-expansion-panels {
  padding: 0px 30px;
  .v-expansion-panel {
    margin: 10px 0px;
    .v-expansion-panel-header {
      padding: 16px;
      border-bottom: 1px solid #d8d8d8;
      height: 50px;
      min-height: 50px;
      ::v-deep .v-expansion-panel-header__icon {
        position: absolute;
        .icon-close {
          transform: rotate(0deg);
        }
        .icon-plus {
          transform: rotate(45deg);
        }
      }
    }
    .v-expansion-panel-content {
      padding: 0px 5px;
      background-color: #f3f8fc;
    }
  }
}
</style>
